import { FormoAnalytics } from "./FormoAnalytics";
export function formofy(writeKey, options) {
    if (writeKey && typeof window !== "undefined") {
        FormoAnalytics.init(writeKey, options)
            .then(function (f) {
            window.formo = f;
        })
            .catch(function (e) { return console.error("Error initializing FormoAnalytics:", e); });
    }
    else {
        console.warn("FormoAnalytics not found");
    }
}
//# sourceMappingURL=initialization.js.map